export const getLocalStorageData = (localStorageKey, defaultData) => {
  const data = localStorage.getItem(localStorageKey);
  if (data) {
    return JSON.parse(data);
  }
  return defaultData ?? {};
};

export const updateLocalStorageData = (localStorageKey, data) => {
  localStorage.setItem(localStorageKey, JSON.stringify(data));
};

export const localStorageKeys = {
  notifications: 'itrack_notifications_filters_v2',
  foreigners: 'itrack_foreigners_filters_v2',
};
